import pathParse from "path-parse";
import * as ActionTypes from "../../constants/statistics/StatisticsActionTypes";

const initialState = {
  standardDate: null,
  activeDate: null,
  activeDateType: null,
  minDate: null,
  hoverDateIndex: null,
  activeDateIndex: null,
  totalCount: 0,
  entryId: pathParse(window.location.pathname).name
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ActionTypes.SET_STANDARD_DATE:
      return Object.assign({}, state, {
        standardDate: action.standardDate
      });

    case ActionTypes.SET_ACTIVE_DATE:
      return Object.assign({}, state, {
        activeDate: action.activeDate
      });

    case ActionTypes.SET_ACTIVE_DATE_TYPE:
      return Object.assign({}, state, {
        activeDateType: action.activeDateType
      });

    case ActionTypes.SET_MIN_DATE:
      return Object.assign({}, state, {
        minDate: action.minDate
      });

    case ActionTypes.SET_HOVER_DATE_INDEX:
      return Object.assign({}, state, {
        hoverDateIndex: action.hoverDateIndex
      });

    case ActionTypes.SET_ACTIVE_DATE_INDEX:
      return Object.assign({}, state, {
        activeDateIndex: action.activeDateIndex
      });

    case ActionTypes.SET_TOTAL_COUNT:
      return Object.assign({}, state, {
        totalCount: action.totalCount
      });

    case ActionTypes.SET_ENTRY_ID:
      return Object.assign({}, state, {
        entryId: action.entryId
      });

    case ActionTypes.INIT_ALL_OF_STORE:
      return Object.assign({}, initialState, {});
  }

  return state
}
